import { PropsWithChildren, ReactNode } from 'react';

import { Heading, Paragraph } from '@/components/common';

interface AlertProps extends PropsWithChildren {
  readonly title?: string;
  readonly description?: ReactNode;
  readonly icon: ReactNode;
}

export function Alert({ title, description, icon, children }: AlertProps) {
  return (
    <div className="flex flex-col items-center text-center m-sm md:m-md p-sm md:p-md bg-white rounded-xl">
      {icon}
      {title && (
        <span className="mt-sm md:mt-md">
          <Heading className="text-[1.125rem] font-extrabold">{title}</Heading>
        </span>
      )}
      {description && (
        <span className="mt-xs">
          <Paragraph extraClassName="font-light">{description}</Paragraph>
        </span>
      )}
      {children && <div className="flex w-full mt-sm md:mt-md">{children}</div>}
    </div>
  );
}
